import { render, staticRenderFns } from "./ezApiPms.vue?vue&type=template&id=2c041361&scoped=true"
import script from "./ezApiPms.vue?vue&type=script&lang=js"
export * from "./ezApiPms.vue?vue&type=script&lang=js"
import style0 from "./ezApiPms.vue?vue&type=style&index=0&id=2c041361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c041361",
  null
  
)

export default component.exports